<template>
  <div style="text-align: center;">
    <img :src="agentApplyQR" style="width: 320px;"/>
  </div>
</template>

<script>
export default {
  name: "服务商申请码",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      agentApplyQR: null
    }
  },
  methods: {
    getAgentApplyQR() {
      this.$apis.common.getAgentApplyQR().then(response => {
        this.agentApplyQR = response.data
      })
    }
  },
  created() {
    this.getAgentApplyQR()
  }
}
</script>

<style scoped>

</style>